import { clientEnv } from "../env";

export interface AppRemoteConfig {
  service: string;
  platform: "web" | "ios" | "android";
  maintenance: { enabled: boolean };
  version: {
    current: string | null;
    minimum: string;
    latest: string;
    updateAvailable: boolean;
    updateRequired: boolean;
    message: string | null;
    storeUrl: string | null;
  };
  features: {
    videoEngineV2: {
      enabled: boolean;
      rolloutPercent: number;
      delivery: {
        resolution: "4K";
        landscape: "3840x2160";
        portrait: "2160x3840";
        strategy: "native-or-ai-upscale";
        validationRequired: true;
      };
    };
    omnisyniaUltra?: { enabled: boolean };
  };
}

export async function fetchAppConfig(signal?: AbortSignal): Promise<AppRemoteConfig> {
  const query = new URLSearchParams({ version: clientEnv.appVersion, platform: "web" });
  const response = await fetch(`${clientEnv.apiBaseUrl}/app/config?${query.toString()}`, { signal });
  if (!response.ok) throw new Error("No se pudo consultar la configuración de OMNISYNIA.");
  return response.json() as Promise<AppRemoteConfig>;
}
